import init from "../base/init"

init(() => {
  const newsBoxEls = document.querySelectorAll(
    "article.news-box",
  )

  const bookedMarkedItems = window.bookmarked_items

  Array.prototype.forEach.call(newsBoxEls, (el) => {
    const { id, type } = el.dataset;
    let bookedMarked = false;
    let currentBookmark = null;

    (bookedMarkedItems?.data || []).forEach((bookmark) => {
      (bookmark?.items || []).forEach((bookmarkContent) => {
        if (id === `${bookmarkContent.id}` && type === `${bookmarkContent.type}`) {
          bookedMarked = true;
          currentBookmark = bookmark;
        }
      });
    });

    if (bookedMarked && currentBookmark) {
      const bookmarkEl = el.querySelector('.lxn-bookmark');
      if (!bookmarkEl) return;

      const bookmarkLink = bookmarkEl.querySelector('a');

      bookmarkEl.style.display = 'block';

      if (!bookmarkLink) return;
      bookmarkLink.href = `/bibliotek/${currentBookmark.slug}`;
      bookmarkLink.title = `Denna artikel är sparad i ${currentBookmark.name}`;
    }
  });
});
